// Catch-all 404 — audience-aware chrome.
//
// BUG (found in the mobile audit, 2026-07-23): main.js used to end with
//   route('*', () => shell('', 'Not found', ...))
// where `shell` is admin/shell.js. A signed-in TENANT who hit any unknown URL was shown the ADMIN
// chrome — the drawer with "Master admin", "Tenancy", "Countries", "Languages". Cosmetic (the API
// gates every admin route with require_admin) but it leaks the platform's internal structure to
// customers. This module picks the chrome that matches who is actually looking:
//   platform admin → the admin shell (drawer + admin bottom bar)
//   tenant         → tenant chrome + the tenant bottom bar, no admin nav anywhere
//   signed out     → neutral chrome with NO nav at all
import { html, navigate } from './shared/t4.js';
import { isAuthed, isAdmin, logout } from './shared/auth.js';
import { theme, toggleTheme } from './shared/theme.js';
import { icon } from './shared/icons.js';
import { bottomNav, tenantNavItems } from './shared/bottomnav.js';
import { shell } from './admin/shell.js';

const notFoundBody = (label, path) => html`
  <div class="page">
    <div class="muted-block">404 — page not found</div>
    <div class="form-actions form-actions-center">
      <button type="button" class="btn btn-primary" @click=${() => navigate(path)}>${label}</button>
    </div>
  </div>`;

export function notFoundScreen(){
  const authed = isAuthed();
  if(authed && isAdmin()) return shell('', 'Not found', notFoundBody('Back to dashboard', '/'));

  const signOut = () => { logout(); navigate('/login'); };
  const body = authed
    ? notFoundBody('Back to home', '/home')
    : notFoundBody('Go to sign in', '/login');

  return html`
    <div class="main tenant-main">
      <header class="app-bar">
        <div class="brand-lockup"><span class="brand-dot"></span><span class="brand-name">aboo</span></div>
        <div class="app-title">Not found</div>
        <div class="app-user">
          <button class="theme-toggle" title="Toggle light / dark"
                  @click=${() => toggleTheme()}>${() => theme.value === 'dark' ? icon('sun', {size: 18}) : icon('moon', {size: 18})}</button>
        </div>
      </header>
      <div class="content">${body}</div>
      ${authed ? bottomNav(tenantNavItems({ onSignOut: signOut })) : ''}
    </div>`;
}
